<script setup lang="ts">
  withDefaults(
    defineProps<{
      fullWidth?: boolean,
    }>(),
    {
      fullWidth: false,
    },
  )
</script>

<template>
  <app-table :full-width="fullWidth">
    <tbody>
      <slot></slot>
    </tbody>
  </app-table>
</template>
